import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NTranslateModule } from '@ebw-monorepo/i18n-translate';
import { ListModule } from '@ebw-monorepo/list';
import { MaterialModule } from '@ebw-monorepo/material';
import { QuillModule } from 'ngx-quill';
import { NotificationMenuComponent } from './notification-menu/notification-menu.component';
import { NotificationService } from './services/notification.service';
import { NotificationComponent } from './notification/notification.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ListModule,
    I18NTranslateModule,
    FormsModule,
    QuillModule.forRoot({
      customOptions: [
        {
          import: 'formats/font',
          whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
        }
      ]
    }),
    ReactiveFormsModule
  ],
  declarations: [NotificationMenuComponent, NotificationComponent],
  exports: [NotificationMenuComponent],
  providers: [NotificationService]
})
export class NotificationModule {}
